import { AddressList } from "../models/address";

export function formatAddressLabel(address: AddressList | null): string | null {
  if (address == null) return null;
  if (address.Name) {
    if (address.Street && address.Nr) return `${address.Name} (${address.Street} ${address.Nr})`;
    if (address.Street) return `${address.Name} (${address.Street})`;
    if (address.PostCode) return `${address.Name} (${address.PostCode} ${address.Location})`;
    else return `${address.Name}`;
  }
  if (address.Street) return `${address.Street ?? ""} ${address.Nr ?? ""}`;
  if (address.PostCode || address.Location)
    return `${address.PostCode ?? ""} ${address.Location ?? ""}`;
  return null;
}
